unit DonationReports;
interface

uses
  System.SysUtils,
  System.Generics.Collections,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.ExtCtrls;

type
  TDonationReportForm = class(TCoreWebForm)
    SelectOn: TLookupComboBox;
    ValueCombo: TLookupComboBox;
    StartDate: TDateTimePicker;
    EndDate: TDateTimePicker;
    RunButton: TButton;
    CloseButton: TButton;
    DateFieldCombo: TLookupComboBox;
    UnclaimedOptionsCombo: TLookupComboBox;
    procedure CloseButtonClick(Sender: TObject);
    procedure RunButtonClick(Sender: TObject);
    procedure SelectOnChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure ValueComboChange(Sender: TObject);
  private
    { Private declarations }
    procedure LoadSelectOn;
    procedure LoadDateFields;
    procedure LoadUnclaimedOptions;
    procedure DetermineOptionsVisibility;
    [async]
    procedure LoadValues; async;
    [async]
    procedure RunReport; async;
    [async]
    procedure SelectOnChangeAsync; async;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  DonationReportForm: TDonationReportForm;

implementation

{$R *.dfm}

uses
  System.DateUtils,
  Essentials.Web.Shared,
  MainDataModule,
  SMX.ReturnTypes,
  Reports.Donation.Utils,
  Reports.Shared,
  SMX.Web.Document.Utils;

procedure TDonationReportForm.CloseButtonClick(Sender: TObject);
begin
  ModalResult := mrClose;
end;

procedure TDonationReportForm.DetermineOptionsVisibility;
begin
  UnclaimedOptionsCombo.Visible := (SelectOn.Value = 'DN.CLAIM_STATUS') and (ValueCombo.Value = 'Unclaimed');
  TDocUtils.ShowHideLabel('donationreports.unclaimedoptions.label', UnclaimedOptionsCombo.Visible);
end;

procedure TDonationReportForm.LoadDateFields;
var
begin
  DateFieldCombo.Clear;
  with DateFieldCombo.LookupValues do
  begin
    AddPair('DN.BANKING_DATE', 'Banking Date');
    AddPair('DN.DATE_ADDED', 'Donation Date Added');
    AddPair('DN.LAST_UPDATED', 'Donation Last Updated');
    AddPair('DR.DATE_ADDED', 'Donor Date Added');
    AddPair('DR.LAST_UPDATED', 'Donor Last Updated');
    AddPair('DN.TRANSACTION_DATE', 'Transaction Date');
  end;

  DateFieldCombo.ItemIndex := DateFieldCombo.LookupValues.Count - 1;
end;

procedure TDonationReportForm.LoadSelectOn;
begin
  SelectOn.LookupValues.AddPair(ALL_DONATIONS, 'All Donations');
  SelectOn.LookupValues.AddPair(GIFT_AID_DONATIONS, 'Giftaid Donations');
  SelectOn.LookupValues.AddPair(NON_GIFT_AID_DONATIONS, 'Non GiftAid Donations');
  SelectOn.LookupValues.AddPair('DN.CLAIM_STATUS', 'Claim Status');
  //SelectOn.LookupValues.AddPair('ImportId', 'Import Batch'); Accessed from Import Manager
  //SelectOn.LookupValues.AddPair('ClaimId', 'Gift Aid Claim'); Accessed from Claims Manager

  SelectOn.LookupValues.AddPair('ANALYSIS_CODE_1', EssentialsManager.CustomNamesManager.EntityFieldName('TDonation',
    'AnalysisCode1'));
  SelectOn.LookupValues.AddPair('ANALYSIS_CODE_2', EssentialsManager.CustomNamesManager.EntityFieldName('TDonation',
    'AnalysisCode2'));
  SelectOn.LookupValues.AddPair('BANKING_REFERENCE', 'Banking Reference');

end;

procedure TDonationReportForm.LoadUnclaimedOptions;
begin
  UnclaimedOptionsCombo.Clear;
  UnclaimedOptionsCombo.LookupValues.AddPair(ONLY_CLAIMABLE_UNCLAIMED_DONATIONS, 'Only Claimable');
  UnclaimedOptionsCombo.LookupValues.AddPair(UNCLAIMED_WITH_ISSUES_DONATIONS, 'Unclaimed with issues');
  UnclaimedOptionsCombo.LookupValues.AddPair(ALL_UNCLAIMED_DONATIONS, 'All Unclaimed');

  UnclaimedOptionsCombo.ItemIndex := 0;
end;

procedure TDonationReportForm.LoadValues;
var
  List: TList<TLookupPair>;
  Val: TLookupPair;
  lSelect: string;
  debugPass: Boolean;
begin
  ValueCombo.LookupValues.Clear;
  ValueCombo.Enabled := (SelectOn.Value <> ALL_DONATIONS) and
                        (SelectOn.Value <> GIFT_AID_DONATIONS) and
                        (SelectOn.Value <> NON_GIFT_AID_DONATIONS);

  if not ValueCombo.Enabled then
    Exit;

  debugPass := XDataToAureliusNames.TryGetValue(SelectOn.Value, {o}lSelect);
  {$IFDEF DEBUG}
  if not debugPass then
    raise Exception.Create('Missing field to DB mapping in XDataToAureliusNames');
  {$ENDIF}

  List := Await(TDonationReportUtils.GetLookupPairs(lSelect));
  for Val in List do
    ValueCombo.LookupValues.AddPair(Val.Value, Val.DisplayText);

  ValueCombo.ItemIndex := 0;
end;

procedure TDonationReportForm.RunButtonClick(Sender: TObject);
begin
  RunReport;
end;

procedure TDonationReportForm.RunReport;
var
  lValue: string;
begin
  RunButton.Enabled := False;
  try
    lValue := ValueCombo.Value;
    if UnclaimedOptionsCombo.Visible then
      lValue := UnclaimedOptionsCombo.Value;  //ALL or ONLY CLAIMABLE unclaimed donations

    Await(TDonationReportUtils.DonationReport(SelectOn.Value, lValue, StartDate.Date, EndDate.Date, DateFieldCombo.Value, '', TReportOutput.roCSV));
  finally
    RunButton.Enabled := True;
  end;
end;

procedure TDonationReportForm.SelectOnChange(Sender: TObject);
begin
  SelectOnChangeAsync;
end;

procedure TDonationReportForm.SelectOnChangeAsync;
begin
  Await(LoadValues);
  DetermineOptionsVisibility;
end;

procedure TDonationReportForm.ValueComboChange(Sender: TObject);
begin
  inherited;
  DetermineOptionsVisibility;
end;

procedure TDonationReportForm.WebFormCreate(Sender: TObject);
begin
  inherited;
//  UnclaimedOptionsCombo.Visible := False;
  LoadSelectOn;
  LoadDateFields;
  LoadUnclaimedOptions;
  StartDate.Date := IncMonth(Yesterday, -1);
  EndDate.Date := Yesterday;

  SelectOn.ItemIndex := 0;
  LoadValues;
  DetermineOptionsVisibility;
end;

procedure TDonationReportForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  SelectOn := TLookupComboBox.Create('donationreports.selecton');
  ValueCombo := TLookupComboBox.Create('donationreports.value.combo');
  StartDate := TDateTimePicker.Create('donationreports.startdate');
  EndDate := TDateTimePicker.Create('donationreports.enddate');
  RunButton := TButton.Create('donationreports.run.button');
  CloseButton := TButton.Create('donationreports.close.button');
  DateFieldCombo := TLookupComboBox.Create('donationreports.datefield.combo');
  UnclaimedOptionsCombo := TLookupComboBox.Create('donationreports.unclaimedoptions.combo');

  SelectOn.BeforeLoadDFMValues;
  ValueCombo.BeforeLoadDFMValues;
  StartDate.BeforeLoadDFMValues;
  EndDate.BeforeLoadDFMValues;
  RunButton.BeforeLoadDFMValues;
  CloseButton.BeforeLoadDFMValues;
  DateFieldCombo.BeforeLoadDFMValues;
  UnclaimedOptionsCombo.BeforeLoadDFMValues;
  try
    Width := 470;
    Height := 214;
    CSSLibrary := cssBootstrap;
    ElementClassName := 'PopUpForm';
    ElementFont := efCSS;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SelectOn.SetParentComponent(Self);
    SelectOn.Name := 'SelectOn';
    SelectOn.Left := 104;
    SelectOn.Top := 88;
    SelectOn.Width := 145;
    SelectOn.Height := 22;
    SelectOn.ElementClassName := 'form-select';
    SelectOn.ElementPosition := epIgnore;
    SelectOn.HeightPercent := 100.000000000000000000;
    SelectOn.WidthPercent := 100.000000000000000000;
    SetEvent(SelectOn, Self, 'OnChange', 'SelectOnChange');
    SelectOn.ItemIndex := -1;
    ValueCombo.SetParentComponent(Self);
    ValueCombo.Name := 'ValueCombo';
    ValueCombo.Left := 280;
    ValueCombo.Top := 88;
    ValueCombo.Width := 145;
    ValueCombo.Height := 22;
    ValueCombo.ElementClassName := 'form-select';
    ValueCombo.HeightPercent := 100.000000000000000000;
    ValueCombo.WidthPercent := 100.000000000000000000;
    SetEvent(ValueCombo, Self, 'OnChange', 'ValueComboChange');
    ValueCombo.ItemIndex := -1;
    StartDate.SetParentComponent(Self);
    StartDate.Name := 'StartDate';
    StartDate.Left := 79;
    StartDate.Top := 128;
    StartDate.Width := 170;
    StartDate.Height := 22;
    StartDate.ElementClassName := 'form-control';
    StartDate.HeightStyle := ssAuto;
    StartDate.BorderStyle := bsSingle;
    StartDate.ChildOrder := 2;
    StartDate.Color := clWhite;
    StartDate.Date := 45986.703537118050000000;
    StartDate.ElementFont := efCSS;
    StartDate.Role := '';
    StartDate.Text := '';
    EndDate.SetParentComponent(Self);
    EndDate.Name := 'EndDate';
    EndDate.Left := 280;
    EndDate.Top := 128;
    EndDate.Width := 170;
    EndDate.Height := 22;
    EndDate.ElementClassName := 'form-control';
    EndDate.HeightStyle := ssAuto;
    EndDate.BorderStyle := bsSingle;
    EndDate.ChildOrder := 2;
    EndDate.Color := clWhite;
    EndDate.Date := 45986.703537118050000000;
    EndDate.ElementFont := efCSS;
    EndDate.Role := '';
    EndDate.Text := '';
    RunButton.SetParentComponent(Self);
    RunButton.Name := 'RunButton';
    RunButton.Left := 256;
    RunButton.Top := 168;
    RunButton.Width := 96;
    RunButton.Height := 25;
    RunButton.Caption := 'Run';
    RunButton.ChildOrder := 4;
    RunButton.ElementClassName := 'btn btn-primary';
    RunButton.ElementFont := efCSS;
    RunButton.HeightStyle := ssAuto;
    RunButton.HeightPercent := 100.000000000000000000;
    RunButton.WidthPercent := 100.000000000000000000;
    SetEvent(RunButton, Self, 'OnClick', 'RunButtonClick');
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 358;
    CloseButton.Top := 168;
    CloseButton.Width := 96;
    CloseButton.Height := 25;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 4;
    CloseButton.ElementClassName := 'btn btn-light';
    CloseButton.ElementFont := efCSS;
    CloseButton.HeightStyle := ssAuto;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
    DateFieldCombo.SetParentComponent(Self);
    DateFieldCombo.Name := 'DateFieldCombo';
    DateFieldCombo.Left := 280;
    DateFieldCombo.Top := 40;
    DateFieldCombo.Width := 145;
    DateFieldCombo.Height := 22;
    DateFieldCombo.ElementClassName := 'form-select';
    DateFieldCombo.ElementFont := efCSS;
    DateFieldCombo.HeightPercent := 100.000000000000000000;
    DateFieldCombo.WidthPercent := 100.000000000000000000;
    DateFieldCombo.ItemIndex := -1;
    UnclaimedOptionsCombo.SetParentComponent(Self);
    UnclaimedOptionsCombo.Name := 'UnclaimedOptionsCombo';
    UnclaimedOptionsCombo.Left := 88;
    UnclaimedOptionsCombo.Top := 24;
    UnclaimedOptionsCombo.Width := 145;
    UnclaimedOptionsCombo.Height := 22;
    UnclaimedOptionsCombo.ElementClassName := 'form-select';
    UnclaimedOptionsCombo.ElementFont := efCSS;
    UnclaimedOptionsCombo.ElementPosition := epIgnore;
    UnclaimedOptionsCombo.HeightPercent := 100.000000000000000000;
    UnclaimedOptionsCombo.WidthPercent := 100.000000000000000000;
    UnclaimedOptionsCombo.ItemIndex := -1;
  finally
    SelectOn.AfterLoadDFMValues;
    ValueCombo.AfterLoadDFMValues;
    StartDate.AfterLoadDFMValues;
    EndDate.AfterLoadDFMValues;
    RunButton.AfterLoadDFMValues;
    CloseButton.AfterLoadDFMValues;
    DateFieldCombo.AfterLoadDFMValues;
    UnclaimedOptionsCombo.AfterLoadDFMValues;
  end;
end;

end.

